import { DataSource, mapDataSource } from '~/Api/DataSource';
import mapGroupedDataSource from '~/Api/DataSource/mapGroupedDataSource';

import type ApiClient from '~/ApiClient';

export interface Result {
	items: DataSource;
}

export default async function findDataSources(client: ApiClient): Promise<Result> {
	const request = await client.fetch('products/searchable-datasources');
	const response = await request.json();
	return { items: response.items.map(mapDataSource) };
}

export async function findGroupedDataSources(client: ApiClient): Promise<Result> {
	const request = await client.fetch('customer-datasource-groups');
	const response = await request.json();
	return { items: response.items.map(mapGroupedDataSource) };
}
